'use client'

import { Heading, Text, Icon, VStack, LinkBox, LinkOverlay } from '@chakra-ui/react'
import Link from 'next/link'
import { FC } from 'react'
import { IconType } from 'react-icons'

export type BlockCardProps = {
  icon: IconType
  title: string
  description: string
  /** Makes the whole card a link to the matching /commerce page. */
  href?: string
}

export const BlockCard: FC<BlockCardProps> = ({ icon, title, description, href }) => {
  return (
    <LinkBox
      p={{ base: 6, md: 10 }}
      bg="background.default"
      border="1px solid"
      borderColor="border.default"
      borderRadius="10px"
      textAlign="center"
      transition="all 0.2s ease"
      _hover={{
        borderColor: 'teal.500',
        transform: 'translateY(-2px)'
      }}
    >
      <VStack spacing={2}>
        <Icon as={icon} w={10} h={10} color="teal.500" mb={2} />
        <Heading as="h3" fontWeight={600} fontSize="1rem" fontFamily="body">
          {href ? (
            <LinkOverlay as={Link} href={href}>
              {title}
            </LinkOverlay>
          ) : (
            title
          )}
        </Heading>
        <Text fontSize="0.85rem" color="text.secondary">
          {description}
        </Text>
      </VStack>
    </LinkBox>
  )
}
